import { api } from "../../lib/api/api";
import { args } from "../../lib/args/args";
import { config } from "../../lib/shared/config";
import { expectShape } from "../../lib/expect/expect-shape";
import { is } from "../../lib/is/is";
import { out } from "../../lib/output/out";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function whoamiCommand(parsed: ParsedArgs): Promise<void> {
  args.expect(parsed, {});

  const identity = expectShape<ApiOutputs["me"]["get"]>(
    await api("/me"),
    "GET /me",
    {
      "user.name": is.string,
      "user.email": is.string,
      "auth.method": is.string,
      "auth.scopes": is.array,
    },
  );

  if (parsed.booleans.has("json")) {
    out.json(identity);
    return;
  }

  out.table([
    [
      out.paint("user", "dim"),
      out.cell(`${identity.user.name} <${identity.user.email}>`),
    ],
    [out.paint("role", "dim"), out.cell(identity.user.role ?? "member")],
    [
      out.paint("auth", "dim"),
      out.cell(
        identity.auth.method === "api_key"
          ? `api key${identity.auth.keyName ? ` "${identity.auth.keyName}"` : ""}`
          : "session",
      ),
    ],
    [out.paint("scopes", "dim"), identity.auth.scopes.join(" ")],
    [out.paint("url", "dim"), config.load().baseUrl],
  ]);
}
